import { useMemo } from 'react';
import { useRootContext } from '../../providers/Root';
export const useDataEnv = (debugName, dataTest, dataTrack) => {
  const {
    env
  } = useRootContext();
  return useMemo(() => Object.assign({
    'data-trk': dataTrack
  }, env === 'prod' ? {} : {
    'data-debug-name': debugName,
    'data-test': dataTest
  }), [env, debugName, dataTest, dataTrack]);
};
//# sourceMappingURL=useDataEnv.js.map